import React, { useEffect, useState } from "react";
import CityStore from "../store/CityStore";
import CategoryStore from "../store/CategoryStore";
import { useNavigate, useLocation } from "react-router-dom";
import CountryStore from "../store/CountryStore";
import CategoryListStore from "../store/CategoryListStore";

function CitySearch() {
  const navigate = useNavigate();
  const location = useLocation();
  const cityData = location.state?.cityData;
  const [category, setCategory] = useState("panel");
  const [activeTab, setActiveTab] = useState("panel");
  const [categoryData, setCategoryData] = useState([]);
  const setCity = CityStore((state) => state.setCity);
  const setGlobalCategory = CategoryStore((state) => state.setCategory);
  const globalCategoryList = CategoryListStore((state) => state.categoryList);
  const country = CountryStore((state) => state.country);

  async function fetchData() {
    try {
      const response = await fetch(
        "/api/get_sub_category.php",
        {
          method: "GET",
        }
      );

      const text = await response.text();
      const cleanedText = text.replace(/[^{}[\],:\"\s0-9a-zA-Z]/g, "");
      const parts = cleanedText.split("}{");

      if (parts.length === 2) {
        const parsedData = JSON.parse(parts);

        if (parsedData.category && Array.isArray(parsedData.category)) {
          setCategoryData(parsedData.category);
          // console.log(parsedData.category);
        } else {
          console.error("Category data not found");
          setCategoryData([]);
        }
      } else {
        console.error("Invalid response structure");
        setCategoryData([]);
      }
    } catch (e) {
      console.error("Error fetching or processing the response:", e);
      setCategoryData([]);
    }
  }

  useEffect(() => {
    // fetchData();
    setCategoryData(Object.keys(globalCategoryList));
  }, []);

  function handleClick(item) {
    setCity(item);
    setGlobalCategory(category);
    const formattedCountry = country.replace(/\s+/g, "-").toLowerCase();
    const formattedCategory = category.replace(/\s+/g, "-").toLowerCase();
    const formattedCity = item.replace(/\s+/g, "-").toLowerCase();
    navigate(`/${formattedCountry}/${formattedCategory}/${formattedCity}`);
  }

  function handleCategory(slug) {
    setActiveTab(slug);
    setCategory(slug);
  }

  return (
    <div className="py-4 font-inter">
      {/* Tab Navigation */}
      <h2 className="text-black text-2xl 2xl:text-3xl my-4">
        <strong>Browse By Cities</strong>
      </h2>
      <div className="flex flex-wrap gap-4 xl:gap-16 2xl:gap-20 my-8 pb-0 border-b-2 gap-12 border-gray-300">
        {categoryData.map((category) => (
          <button
            key={category}
            onClick={() => handleCategory(category)}
            className={`pb-2 text-lg ${
              activeTab === category
                ? "border-b-2 border-black text-black"
                : "text-[#9CA3AF]"
            } hover:text-black transition`}
          >
            {category[0].toUpperCase() + category.slice(1)}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 md:gap-8 overflow-hidden">
        {cityData &&
          cityData.map((city, index) => (
            <button
              key={index}
              className="text-gray-600 text-left hover:text-black cursor-pointer text-base 2xl:text-lg truncate"
              onClick={() => handleClick(city.city_name)}
            >
              {city.city_name}
            </button>
          ))}
      </div>
    </div>
  );
}

export default CitySearch;